import { Button } from "antd";
import { Dispatch, SetStateAction, useState, useEffect } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { useReactiveVar } from "@apollo/client";

import "./storyTime.scss";
import type { StoryTimeListType } from "./content/storyTimeType"
import StoryTimeList from "./storyTimeList"
import StoryTimeModal from "./storyTimeModal"
import { header } from "../utils/zippyAdminHeader";
import Spinner from "../../../components/layout/spinner/Spinner";
import NoPermission from "../../../components/others/NoPermission";
import ContentTitle from "../../../components/ui/ContentTitle";
import { useGetUserProgramsByServiceQuery } from "../../../graphql/operations/get-user-program-by-service";
import { __currentUser__ } from "../../../graphql/policies";
import { ServiceTypes } from "../../../types/types";
import { apiCall } from "../../../utils/apiCall";
import { renderDecodedId } from "../../../utils/renderDecodedId";

interface StoryTimeProps {
  setSelectedService: Dispatch<SetStateAction<ServiceTypes>>;
  setSelectSubItem: Dispatch<SetStateAction<string | undefined>>;
}

const StoryTime = ({
  setSelectedService,
  setSelectSubItem,
}: StoryTimeProps) => {
  const [data, setData] = useState([]);
  const [editMainData, setEditMainData] = useState<StoryTimeListType | undefined>();
  const [modalAction, setModalAction] = useState<"Create" | "Edit">("Create");
  const [openMainModal, setOpenMainModal] = useState(false);

  const currentUser = useReactiveVar(__currentUser__);
  const userName = currentUser?.userName;

  const { data: userPrograms, loading: userProgramsLoading } =
    useGetUserProgramsByServiceQuery({
      variables: {
        userId: parseInt(renderDecodedId(currentUser?.id)),
        serviceId: 10,
      },
    });

  const fetchStoryTimeList = async () => {
    const data = await apiCall({
      method: "GET",
      header: header,
      endPoint:
        process.env.REACT_APP_ZIPPY_ADMIN +
        "/stories/admin"
    });

    if (data) {
      setData(data);
    }
  }

  useEffect(() => {
    setSelectedService(ServiceTypes.ZIPPY_AND_ME);
    setSelectSubItem("Story Time");
    fetchStoryTimeList();
  }, []);

  if (userProgramsLoading) {
    return <Spinner />;
  }

  if (
    userPrograms &&
    !userPrograms.wf_adminFirst_afUserProgram?.edges?.find(
      (item) => item.node.afProgram?.programName === "Story Time"
    )
  ) {
    return <NoPermission />;
  }

  return (
    <>
      <div id="storyTimeWrapper">
        <ContentTitle title="Story Time" />
        <div className="table-container">
          <div>
            <div className="table-menu-container">
              <p className="text-base font-medium">Total {data.length} stories</p>
              <Button
                type="primary"
                style={{ marginLeft: 8 }}
                icon={<PlusOutlined />}
                onClick={() => {
                  setModalAction("Create");
                  setOpenMainModal(true);
                  setEditMainData(undefined);
                }}
              >
                Create New Story
              </Button>
            </div>
            <StoryTimeList
              data={data}
              setModalAction={setModalAction}
              setOpenMainModal={setOpenMainModal}
              setEditMainData={setEditMainData}
              refresh={fetchStoryTimeList}
            />
            <StoryTimeModal
              storyTimeData={editMainData}
              open={openMainModal}
              type={modalAction}
              userName={userName!}
              setOpenMainModal={setOpenMainModal}
              setEditMainData={setEditMainData}
              refresh={fetchStoryTimeList}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default StoryTime;
